import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@mui/material'
import React from 'react'
import { useAppSelector } from '../../../../app/hooks'
import { images } from '../../../../constants'

import { type StarChartsListPresentationProps } from '../../types/types'
import StarChartsItemPresentation from '../starChart.item.presentation/StarChartItemPresentation'
import { setMetaData } from '../../adminSlice/adminSlice'


const StarChartsListPresentation: React.FC<StarChartsListPresentationProps> = ({
  onStarChartDelete,
  starChartsList,
  page,
  setPage,
  limit,
  setLimit,
  sort,
  onSort
}) => {
  const metaData = useAppSelector(setMetaData)

  return (
    <div
      style={{
        width: '90%',
        background: '#fff',
        marginLeft: 50,
        minHeight: 'calc(100vh - 238px)'
      }}
    >
      <div style={{ boxShadow: '0 10px 20px rgba(18, 38, 63, 0.03)' }}>
        <TableContainer>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell style={{width:120}}></TableCell>
                <TableCell
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    onSort!('firstName')
                  }}
                >
                  <div
                    style={{
                      textAlign: 'start',
                      fontSize: 13,
                      justifyContent: 'flex-start',
                      fontWeight: 600,
                      fontFamily: 'Poppins',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    Name{' '}
                    {sort !== 'firstName' && sort !== '-firstName'
                      ? (
                      <img
                        src={images.unSelectIcon}
                        alt="unselect"
                        style={{ paddingLeft: 4 }}
                      />
                        )
                      : sort !== '-firstName'
                        ? (
                      <img
                        src={images.BottomIcon}
                        alt="bottom"
                        style={{ paddingLeft: 4 }}
                      />
                          )
                        : (
                      <img
                        src={images.topIcon}
                        alt="top"
                        style={{ paddingLeft: 4 }}
                      />
                          )}
                  </div>
                </TableCell>
                <TableCell
                  onClick={() => {}}
                >
                  <div
                    style={{
                      maxWidth: 120,
                      textAlign: 'center',
                      fontSize: 13,
                      justifyContent: 'center',
                      fontWeight: 600,
                      fontFamily: 'Poppins',
                      display: 'flex',
                      alignItems: 'center',
                      cursor:"pointer"
                    }}
                  >
                    Experiences{' '}
                    {sort !== '' && sort === ''
                      ? (
                      <img
                        src={images.unSelectIcon}
                        alt="unselect"
                        style={{ paddingLeft: 4 }}
                      />
                        )
                      : sort === ''
                        ? (
                      <img
                        src={images.BottomIcon}
                        alt="bottom"
                        style={{ paddingLeft: 4 }}
                      />
                          )
                        : (
                      <img
                        src={images.topIcon}
                        alt="top"
                        style={{ paddingLeft: 4 }}
                      />
                          )}
                  </div>
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {starChartsList.ids.map((id) => (
                <StarChartsItemPresentation key={id} item={starChartsList.entities[id]!} onStarChartDelete={onStarChartDelete}/>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {metaData?.payload.admin.metadata?.toatlCount > 23 && (
          <TablePagination
            component="div"
            count={metaData?.payload.admin.metadata.toatlCount}
            page={page! - 1}
            rowsPerPage={limit!}
            rowsPerPageOptions={[25, 50, 100]}
            onPageChange={(event: unknown, newPage: number) => {
              setPage!(newPage + 1)
            }}
            onRowsPerPageChange={(
              event: React.ChangeEvent<HTMLInputElement>
            ) => {
              setLimit!(parseInt(event.target.value, 10))
            }}
          />
        )}
      </div>
    </div>
  )
}

export default StarChartsListPresentation
